<template>
  <div>
    <div class="interest-free">
      <header></header>
      <div class="main">
        <div class="main-content"></div>
        <nd-button class="button"
                   @click="download"
        >下载{{ isIos === 'IOS' ? '天美钱包' : '天美贷' }}立即领取
        </nd-button>
        <div class="list-item">
          <div class="item">
            <img
              src="./images/icon_01.png"
            />
            <div class="text-1">快速审批</div>
            <div class="text-2">最快5分钟放款</div>
          </div>
          <div class="item">
            <img
              src="./images/icon_02.png"
            />
            <div class="text-1">分期偿还</div>
            <div class="text-2">可分12期偿还</div>
          </div>
          <div class="item">
            <img
              src="./images/icon_03.png"
            />
            <div class="text-1">放心使用</div>
            <div class="text-2">正规持牌机构</div>
          </div>
        </div>
        <div class="main-foot">最长用12个月，综合年化利率15.4%起（单利计算）</div>
      </div>
    </div>
    <ios-download v-model="downloadVisible"></ios-download>
  </div>
</template>

<script>
import { judgeClientSystem } from '@/assets/utils'
export default {
  name: 'tbs-migration',
  data () {
    return {
      isIos: judgeClientSystem(),
      showImage: false
    }
  },
  methods: {
    callAppBySchema (schema) {
      return new Promise((resolve, reject) => {
        let node = document.createElement('iframe')
        const body = document.body
        node.style.display = 'none'

        let clear = function (evt, isTimeout) {
          node.onload = null
          body.removeChild(node)
          node = null
        }

        node.onload = clear
        node.src = schema
        body.appendChild(node)
        let now = Date.now()

        setTimeout(() => {
          let newTime = Date.now()

          if (newTime - now > 1100) {
            resolve(true)
          } else {
            resolve(false)
          }
          clear()
        }, 1000)
      })
    },
    download () {
      this.downloadApp()
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.interest-free {
    width: 750px;
    background: #ED3F31;
    padding-bottom:40px;
    .main{
        position: relative;
        width: 750px;
        height: 1136px;
        background: url('./images/img_mao.png');
        background-size:100%;
        padding-top:335px;
        .button {
        position: relative;
        margin: 25px auto 0;
        width: 580px;
        height: 100px;
        background: linear-gradient(90deg, #FE3001 0%, #FD7118 100%);
        box-shadow: 0px 14px 20px 0px rgba(237, 63, 49, 0.3);
        border-radius: 60px;
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        }
        .list-item {
            display: flex;
            justify-content: space-between;
            padding: 0 60px;
            margin-top: 63px;
            .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                > img {
                    width: 90px;
                    height: 90px;
                }
                .text-1 {
                    margin-top: 18px;
                    font-size: 28px;
                    text-align: center;
                    color: #333333;
                    line-height: 40px;
                }
                .text-2 {
                    font-size: 24px;
                    text-align: center;
                    color: #999999;
                    line-height: 40px;
                }
            }
        }
        &-content{
        margin:auto;
        width: 534px;
        height: 270px;
        background: url("./images/img_quan.png");
        background-size: 100% 100%;
        }
        &-foot{
        width: 690px;
        height: 66px;
        line-height: 66px;
        background: #FFEDE2;
        margin:47px auto 0;
        text-align: center;
        >span{
            height: 33px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #A07979;
            line-height: 33px;
        }
        }
    }
    header{
      height:285px;
      width:750px;
      background:url('./images/img_font.png') no-repeat;
      background-size: 100%;
    }
}
</style>
